<template>
  <v-dialog
    v-model="dialog"
    :content-class="'video-feedback-' + videoEnabled"
    :hide-overlay="videoEnabled"
    :persistent="videoEnabled"
    :no-click-animation="videoEnabled"
    :v-if="devices.length"
  >
    <template v-slot:activator="{ on: { click } }">
      <v-tooltip
        v-model="showTooltip"
        top
        color="transparent"
        content-class="help-bubble"
        nudge-left="100%"
        :disabled="dialog"
        @click.native="showTooltip = false"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            @click="click"
            v-on="on"
            :active="dialog"
            color="primary"
            tile
            :fab="!$vuetify.breakpoint.mdAndUp"
            :small="!$vuetify.breakpoint.mdAndUp"
          >
            <v-icon>mdi-camera-front-variant</v-icon>
            <span class="ml-1" v-show="$vuetify.breakpoint.mdAndUp">{{
              $t("participant.live.toolbar.videofeedback")
            }}</span>
          </v-btn>
        </template>
        <v-card width="350px">
          <v-card-title>{{ $t("participant.live.videofeedback.help.title") }}</v-card-title>
          <v-card-text class="text-justify">{{ $t("participant.live.videofeedback.help.text") }}</v-card-text>
        </v-card>
      </v-tooltip>
    </template>
    <v-card v-show="videoEnabled" dark tile>
      <v-toolbar dense absolute flat class="video-toolbar right">
        <v-btn v-if="currentDeviceId && devices.length > 1" icon @click="switchCamera" small>
          <v-icon>mdi-rotate-3d-variant</v-icon>
        </v-btn>
        <v-btn icon @click="dialog = false" small>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <video ref="video" autoplay></video>
    </v-card>
    <v-card v-if="!videoEnabled">
      <v-card-title>{{ $t("participant.live.videofeedback.popup.title") }}</v-card-title>
      <v-card-text>
        {{ $t("participant.live.videofeedback.popup.content") }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false">{{ $t("participant.live.videofeedback.popup.cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      videoEnabled: false,
      devices: [],
      currentDeviceId: null,
      dialog: false,
      stream: null,
      showTooltip: false,
      autoShowTooltip: null,
    };
  },
  async mounted() {
    await this.loadDevices("videoinput");
  },
  watch: {
    async dialog(value) {
      if (value) {
        this.enable();
      }
    },
    showTooltip() {
      if (this.autoShowTooltip) {
        clearTimeout(this.autoShowTooltip);
        this.autoShowTooltip = null;
      }
    },
  },
  methods: {
    async enable(deviceId) {
      try {
        this.stream = await this.getUserMedia({
          video: {
            facingMode: "user",
            deviceId: deviceId && { exact: deviceId },
          },
        });
        this.videoEnabled = true;
        this.$refs.video.srcObject = this.stream;
        this.$refs.video.play();
      } catch (err) {
        this.dialog = false;
        this.videoFeedback = false;
      }
      try {
        this.currentDeviceId = this.stream.getVideoTracks()[0].getSettings().deviceId;
      } catch (e) {
        // not empty ;)
      }
    },
    async loadDevices(kind) {
      if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        const devices = await navigator.mediaDevices.enumerateDevices();
        this.devices = devices.filter((d) => d.kind === kind);
      }
    },
    async switchCamera() {
      const currentIndex = this.devices.indexOf(this.devices.find((e) => e.deviceId === this.currentDeviceId));
      const nextDevice = this.devices[(currentIndex + 1) % this.devices.length];
      this.enable(nextDevice.deviceId);
    },
    async getUserMedia(settings) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // Not adding `{ audio: true }` since we only want video now
        return await navigator.mediaDevices.getUserMedia(settings);
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
// unscoped scss in order to apply to dialog content
.video-feedback-false {
  width: 400px !important;
}

.video-feedback-true {
  bottom: 0;
  right: 0;
  position: fixed;
  margin: 0 !important;
  width: 50vw !important;
  video {
    max-height: 60vh;
    width: 100%;
  }
}

@media (max-aspect-ratio: 3/4) {
  .video-feedback-true {
    width: 100vw !important;
    video {
      max-height: 44vh;
    }
  }
}

.help-bubble:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-top-color: white;
  border-bottom: 0;
  border-right: 0;
  margin-left: 25px;
  margin-bottom: -15px;
}

@media (pointer: none), (pointer: coarse) {
  .help-bubble {
    display: none !important;
  }
  .help-bubble:after {
    display: none !important;
  }
}

.theme--dark .help-bubble:after {
  border-top-color: #303030;
}
</style>
